import React from 'react';
import { PanelItemFrame } from '../../panel-item-frame/panel-item-frame';
import { PanelItemFrameProps } from '../../panel-item-frame/panel-item-frame.props';

export const PanelItemSection = (props: PanelItemFrameProps) => {
  return <PanelItemFrame {...props} />;
};
